import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useBul } from "./BulLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function ExecutiveBodyPage() {
  const data = useBul();
  const list = data.executive_body || [];
  return (
    <div data-testid="bul-eb-page-wrap">
      <PageHero eyebrow="About" title="Executive Body Members" />
      <PageBody>
        <BodyMembersTable members={list} theme="cream" testidPrefix="bul-eb-page" />
      </PageBody>
    </div>
  );
}
